import React, { Component } from 'react';
import { Select, MenuItem, Input } from "@material-ui/core";

import SpotlioIcon from '../Icon';

import { getSystemSettings } from "../../utils/SettingsRetriever";
 
import './QuantitySelector.scss';

class QuantitySelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.default ? this.props.default : 0,
            ...this.getQuantities(this.props),
            hasChanged: this.props.make ? true : false
        }
    }

    isDropdownCustom = () => {
        if (getSystemSettings().app && getSystemSettings().app.dropdownQuantities && getSystemSettings().app.dropdownQuantities.type === "combined") {
            return true;
        }

        return false;
    }

    getQuantities = (props) => {
        let max = 50;
        let min = 1;

        max = props.max;
        if (props.min !== undefined) min = props.min;

        if (getSystemSettings().app && getSystemSettings().app.dropdownQuantities && getSystemSettings().app.dropdownQuantities.dropdownMin && getSystemSettings().app.dropdownQuantities.dropdownMax) {
            min = getSystemSettings().app.dropdownQuantities.dropdownMin;
            max = getSystemSettings().app.dropdownQuantities.dropdownMax;
        }

        return { min, max };
    }

    shouldComponentUpdate(nextProps){
        if (nextProps.max !== this.state.max || nextProps.min !== this.props.min) return true;
        if (!this.props.value){
            if (!this.state.hasChanged){
                return false
            } else {
                return true;
            }
        } else {
            return true;
        }

    }

    componentWillReceiveProps(nextProps){
        if (this.state.value !== nextProps.default || this.state.max !== nextProps.max || this.state.min !== nextProps.min){
            this.setState({
                value: nextProps.default,
                ...this.getQuantities(nextProps),
            })
        }
    }

    renderDropdownItems = () => {
        let { min, max } = this.state;
        const isNative = this.props.native;

        let arrayOfItems = Array.from(new Array(max - min + 1), (val, index) => {
            const optionProps = {
                key: index + min,
                value: index + min
            }
            let optionValue = this.getLabelValue(
                (index + min).toString()
            );

            return isNative ? <option {...optionProps}>{optionValue}</option> : <MenuItem {...optionProps}>{optionValue}</MenuItem>;
        })

        return arrayOfItems;
    }

    getCurrentMax = () => {
        let max = this.state.max;

        if (this.isDropdownCustom() && getSystemSettings().app.dropdownQuantities.maxAmount) {
            max = getSystemSettings().app.dropdownQuantities.maxAmount
        }

        if (this.props.max && this.props.max < max) {
            max = this.props.max
        }

        return max;
    }

    handleChange = (event) => {
        this.setState({
            value: event.target.value <= this.getCurrentMax() && event.target.value >= this.state.min ? event.target.value : this.state.value,
            hasChanged: true,
            displayInput: event.target.value > this.state.max && this.isDropdownCustom() ? true : this.state.displayInput,
            showWarning: event.target.value > this.getCurrentMax() ? true : false
        }, 
            () => { 
                this.props.whenChange(this.props.name, this.state.value);
            }
        )
    }

    getCustomValue = () => {
        if (this.isDropdownCustom()) {
            return(
                this.props.native ? <option key={this.state.max + 1} value={this.state.max + 1}>{getSystemSettings().app.dropdownQuantities.customAmountText}</option> : <MenuItem key={this.state.max + 1} value={this.state.max + 1}>{getSystemSettings().app.dropdownQuantities.customAmountText}</MenuItem>
            )
        }
        return null;
    }

    getLabelValue = (value) => {
        let label = '';
        const icon = <SpotlioIcon size={12} icon={'feather-chevron-down'} />;

        if(this.props.showSymbol !== undefined){
            label = this.props.showSymbol + " ";
        } else {
            if(this.props.showName){
                label = value + " " + this.props.name;
                if(!this.state.hasChanged){
                    label = "Select " + this.props.name;
                }

                label += " " + icon;
            }
        }
        

        label += value;

        return label;
    }

    render() {

        return (
            <div className="quantitySelectorWrapper">
                {
                    this.state.displayInput 
                    ?
                        <>
                            <Input 
                                onBlur={() => this.state.value < this.state.min && this.setState({ value: this.state.min }, () => this.props.whenChange(this.props.name, this.state.value))}
                                autoFocus={true}
                                variant="outlined"
                                name={this.props.name}
                                value={this.props.value !== undefined ? this.props.value : this.state.value}
                                onChange={this.handleChange}
                                className={`quantitySelector ${(!this.props.className ? 'default' : this.props.className)} input`}
                                type="number"
                                inputProps={{ min: this.state.min, max: this.getCurrentMax() }}
                            />
                            {
                                this.state.showWarning &&
                                <div className="tooltip">
                                    Max amount is {this.getCurrentMax()}
                                </div>
                            }
                        </>
                    :
                    <Select
                        variant={'outlined'}
                        name={this.props.name}
                        value={this.props.value !== undefined ? this.props.value : this.state.value}
                        onChange={this.handleChange}
                        className={`quantitySelector ${(!this.props.className ? 'default' : this.props.className)}`}
                        inputProps={{
                            name: 'ammount'
                        }}
                        renderValue={(value)=>
                            <React.Fragment>
                                { this.getLabelValue(value) }
                            </React.Fragment>
                        }
                        native={this.props.native ? true : false}
                        IconComponent={props => 
                            <SpotlioIcon {...props} icon="feather-chevron-down" />
                        } 
                    >
                        { this.renderDropdownItems() }
                        {this.getCustomValue()}
                    </Select>
                    // 9bfec1db10afabdcc60eb0f431b9ad5f0cea50c0
                }
            </div>
        );
    }
}

export default QuantitySelector;
